import { brand } from '../../../theme/themePrimitives';
import CustomModal from '../../modals';
import { Button, Typography } from '@mui/material';

const FetchDataModal = ({ open, onClose, name }: { open: boolean; onClose: () => void, name: string }) => {
    return (
        <CustomModal open={open} handleClose={onClose} title={`Fetching Data of ${name}`}>
            <Typography
                variant="subtitle2"
                color={brand[300]}
                fontWeight="bold"
                align="center"
                mb={2}
            >
                Hang tight! We are retrieving your prospects. This list will be available in Recent Searches when available
            </Typography>
            <Button variant="contained" fullWidth onClick={onClose}>
                OK
            </Button>
        </CustomModal>);
};

export default FetchDataModal;